// extracted by mini-css-extract-plugin
module.exports = {"widget":"_93444fe79c--widget--BYm0l"};